module.exports = __webpack_public_path__ + "kangping/img/1.9536f072.png";